module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "8.8e763b36.jpg" + "?" + Date.now();